import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import FormikFocusError from "app/common/form/FormikFocusError";
import {
  APPOINTMENT_STATUS,
  APPOINTMENT_TYPE,
  TIME_FRAME,
} from "app/common/LocalConst";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import IconDelete from "app/common/Icon/IconDelete";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { pagingServiceGroup } from "app/services/ServiceGroupService";
import { FieldArray, getIn } from "formik";
import moment from "moment";
import { pagingDepartment } from "app/services/DepartmentService";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import { pagingPatientRank } from "app/services/PatientRank";
import { pagingPatientType } from "app/services/PatientType";
import { pagingPatientGroup } from "app/services/PatientGroupType";
import { pagingCustomerSourceGroup } from "app/services/CustomerSourceGroupService";
import PatientAddress from "app/PatientManagement/PatientList/Form/PatientAddress";
import { transformDate } from "app/common/LocalFunction";
import * as Yup from "yup";
const AppointmentListPopup = ({
  open,
  handleClose,
  handleSubmit,
  initialValues,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const withSpaceName = (name) => {
    return `patient.${name}`;
  };

  const validationSchema = Yup.object().shape({
    patient: Yup.object().shape({
      displayName: Yup.string().required("Tên khách hàng không được bỏ trống"),
    }),
    orderTime: Yup.date()
      .transform(transformDate)
      .typeError("Thời gian đặt lịch không đúng định dạng !")
      .required("Thời gian đặt lịch không được bỏ trống !")
      .nullable(),
    startTime: Yup.date()
      .transform(transformDate)
      .typeError("Thời gian bắt đầu dự kiến không đúng định dạng !")
      .required("Thời gian bắt đầu dự kiến không được bỏ trống !")
      .nullable(),
    department: Yup.object().required("Cơ sở không được bỏ trống !").nullable(),
    appointmentType: Yup.number()
      .required("Loại lịch không được bỏ trống !")
      .nullable(),
  });
  return (
    <PopupForm
      open={open}
      size="lg"
      handleClose={handleClose}
      title={"Cập nhật lịch hẹn khách hàng"}
      formik={{
        initialValues: initialValues,
        onSubmit: handleSubmit,
        enableReinitialize: true,
        validationSchema: validationSchema,
      }}
      action={({ submitForm, setFieldValue,isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" disabled={isSubmitting} className="btn-primary">
              {!isMobile && <Save className="mr-2 " />}
              Cập nhật
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              {!isMobile && <Block className="mr-2" />}
              Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values, setSubmitting }) => {
        return (
          <>
            <FormikFocusError />
            <Grid container spacing={1} className="w-100 m-0">
              <Grid item xs={12} sm={12}>
                <div
                  className="item-form-patient"
                  style={{
                    borderEndStartRadius: "5px",
                    borderEndEndRadius: "5px",
                  }}
                >
                  <p className="item-form-header flex align-center">
                    1 {t("Thông tin khách hàng")}
                  </p>

                  <Grid container spacing={1} className="w-100 m-0">
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsTextField
                        name={withSpaceName("code")}
                        label="Mã khách hàng"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsTextField
                        name={withSpaceName("displayName")}
                        label="Họ tên khách hàng"
                        autoUpercase
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsTextField
                        label={t("Số điện thoại")}
                        name={withSpaceName("phoneNumber")}
                        disabled
                      />
                    </Grid>

                    <PatientAddress nameSpace={"patient"} disabledForm={true} />
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsPagingAutocomplete
                        api={pagingCustomerSourceGroup}
                        name={withSpaceName("currentPatientSource")}
                        label="Nguồn khách hàng"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsPagingAutocomplete
                        api={pagingPatientGroup}
                        name={withSpaceName("currentPatientGroup")}
                        label={t("Nhóm khách hàng")}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsPagingAutocomplete
                        name={withSpaceName("currentPatientType")}
                        label={t("Loại khách hàng")}
                        api={pagingPatientType}
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsPagingAutocomplete
                        name={withSpaceName("currentPatientRank")}
                        label={t("Hạng khách hàng")}
                        api={pagingPatientRank}
                        disabled
                      />
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div
                  className="item-form-patient"
                  style={{
                    borderEndStartRadius: "5px",
                    borderEndEndRadius: "5px",
                  }}
                >
                  <p className="item-form-header flex align-center">
                    2 {t("Thông tin lịch")}
                  </p>

                  <Grid container spacing={1} className="w-100 m-0">
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsDateTimePicker
                        label="Thời gian đặt lịch"
                        name="orderTime"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsDateTimePicker
                        label="Thời gian bắt đầu"
                        name="startTime"
                        isDateTimePicker
                        onChange={(startTime) => {
                          setFieldValue("startTime", startTime);

                          const avgTime =
                            values?.totalEstimatedTime ||
                            values?.department?.avgConsultationTime;

                          if (startTime && avgTime) {
                            const endTime = moment(startTime).add(
                              avgTime,
                              "minutes"
                            );
                            setFieldValue("endTime", endTime);
                          }
                        }}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsSelectInput
                        options={TIME_FRAME}
                        freeSolo
                        label="Dự kiến"
                        name="totalEstimatedTime"
                        onChange={(e) => {
                          let totalEstimatedTime = e?.target?.value;

                          setFieldValue(
                            "totalEstimatedTime",
                            totalEstimatedTime
                          );

                          const startTime = values?.startTime;

                          if (startTime && totalEstimatedTime) {
                            const endTime = moment(startTime).add(
                              +totalEstimatedTime,
                              "minutes"
                            );
                            setFieldValue("endTime", endTime);
                          }
                        }}
                        placeholder="( Phút )"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsDateTimePicker
                        label="Thời gian kết thúc dự kiến"
                        name="endTime"
                        isDateTimePicker
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsPagingAutocomplete
                        name={"department"}
                        label={"Cơ sở"}
                        api={pagingDepartment}
                        onChange={async (_, option) => {
                          setFieldValue("department", option);
                          const avgTime = option?.avgConsultationTime;
                          if (avgTime) {
                            setFieldValue("totalEstimatedTime", avgTime);
                          }

                          if (values?.startTime && avgTime) {
                            const endTime = moment(values?.startTime).add(
                              avgTime,
                              "minutes"
                            );
                            setFieldValue("endTime", endTime);
                          }
                        }}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsSelectInput
                        options={APPOINTMENT_TYPE}
                        name="appointmentType"
                        label={"Loại lịch"}
                        onChange={(e) => {
                          const selectedType = e.target.value;
                          setFieldValue("appointmentType", selectedType);
                          if (selectedType === APPOINTMENT_TYPE[0].value) {
                            const startTime = values?.startTime;
                            const avgTime =
                              values?.department_id?.avgConsultationTime;

                            if (startTime && avgTime) {
                              const endTime = moment(startTime).add(
                                avgTime,
                                "minutes"
                              );
                              setFieldValue("endTime", endTime);
                            }
                          } else {
                            setFieldValue("endTime", null);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsSelectInput
                        options={APPOINTMENT_STATUS}
                        name="status"
                        label={"Trạng thái"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsTextField
                        name={"note"}
                        label="Ghi chú/lý do đặt lịch"
                        isTextArea
                      />
                    </Grid>
                    {values?.appointmentType === APPOINTMENT_TYPE[0].value && (
                      <Grid item xs={12} sm={6} md={6}>
                        <FieldArray name="serviceGroups">
                          {({ remove, push }) => (
                            <>
                              <Grid container>
                                <Grid item xs={12} sm={5} md={5}>
                                  <GlobitsPagingAutocomplete
                                    disableClearable
                                    label={"Chọn nhóm DV khách hàng quan tâm"}
                                    api={pagingServiceGroup}
                                    name={`serviceChoose`}
                                    searchObject={{
                                      isUse: true
                                    }}
                                    autoUpercase
                                    onChange={(_, value, reason, option) => {
                                      push({
                                        serviceGroup: value,
                                      });
                                      if (reason === "remove-option") {
                                        return;
                                      }
                                    }}
                                    renderTags={() => ""}
                                    value={values?.serviceChoose || []}
                                    getOptionDisabled={(option) => {
                                      const selectedService = getIn(
                                        values,
                                        "serviceGroups"
                                      );

                                      if (
                                        selectedService?.find(
                                          (it) =>
                                            it?.serviceGroup?.id === option?.id
                                        )
                                      ) {
                                        return true;
                                      }
                                      return false;
                                    }}
                                  />
                                </Grid>

                                <Grid item xs={12}>
                                  <div
                                    className="table-root mt-2"
                                    style={{ width: "100%" }}
                                  >
                                    <table className="table-container">
                                      <thead>
                                        <tr className="row-table-header">
                                          <th width="5%">STT</th>
                                          <th width="40%">Mã nhóm dịch vụ</th>
                                          <th width="40%">Tên nhóm dịch vụ</th>

                                          <th>Thao tác</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {values?.serviceGroups?.length > 0 &&
                                          values?.serviceGroups?.map(
                                            (item, index) => {
                                              return (
                                                <tr key={index}>
                                                  <td align="center">
                                                    {index + 1}
                                                  </td>
                                                  <td>
                                                    <GlobitsTextField
                                                      name={`serviceGroups[${index}].serviceGroup.code`}
                                                      disabled
                                                    />
                                                  </td>
                                                  <td>
                                                    <GlobitsPagingAutocomplete
                                                      api={pagingServiceGroup}
                                                      name={`serviceGroups[${index}].serviceGroup`}
                                                    />
                                                  </td>

                                                  <td align="center">
                                                    <span
                                                      tooltip={"Xóa"}
                                                      className="pointer tooltip"
                                                      onClick={() =>
                                                        remove(index)
                                                      }
                                                    >
                                                      <IconDelete />
                                                    </span>
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </Grid>
                              </Grid>
                            </>
                          )}
                        </FieldArray>
                      </Grid>
                    )}
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </>
        );
      }}
    </PopupForm>
  );
};

export default memo(observer(AppointmentListPopup));
